module.exports = __webpack_public_path__ + "img/info_round_b.80cff76f.svg";